module.exports = __webpack_public_path__ + "static/media/employee.09098599.png";